// 封装axios
import axios from 'axios'
import { Toast } from 'vant'
import router from '@/router'

let http = axios.create({
  // 基础路径 此路径会被nginx转发到实际服务器服务路径.
  baseURL: '/api',
  // 超时时间
  timeout: 60000
})


// 响应拦截
// 处理每次请求的结果(成功和失败)
http.interceptors.response.use((res) => {
  res.headers = {
    'Content-Type': 'application/json;charset=UTF-8'
  }
  return res.data
}, err => {
  // 每次请求失败的状态码
  let status = err.response && err.response.status
  if (status === 424) {
    localStorage.removeItem('access_token')
    localStorage.removeItem('isPreviewMode')
    router.push('/Login').catch(err => { })
  }
  if (status === 400) {
    Toast.fail('参数错误')
  }
  if (status === 401) {
    Toast.fail('登录过期')
  }
  if (status === 403) {
    Toast.fail('没有全选')
  }
  if (status === 404) {
    Toast.fail('路径错误')
  }
  if (status === 500) {
    Toast.fail('服务器错误')
  }
  if (status === 503) {
    Toast.fail('服务器维护')
  }
  return Promise.reject(err.response.data)
})




export default http